var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{attrs:{"to":_setup.toolLink}},[_c('b',[_vm._v(_vm._s(_setup.toolName || _vm.toolId))]),_vm._v(" (Galaxy Version "+_vm._s(_vm.toolVersion)+")\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }